import React from "react";
import { Route, Routes } from "react-router";
import Disposed from "./Disposed";
import FixedAssets from "./FixedAssets";
import ResourceNotFound from "../../Common/ResourceNotFound";
import AssetLocation from "./AssetLocation";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Users/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { useClient } from "../../Context/ClientContext";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";

const AssetsNestedRoute: React.FC = () => {
  const { clientSpecificRole } = useUser();
  const { currentClient } = useClient();

  return (
    <div>
      <Routes>
        <Route
          path="/fixedAsset"
          element={
            findUserPremission(
              ["Voucher.Asset.FixedAsset.View"],
              clientSpecificRole(),
              currentClient?.id!,
              [SettingsSections.Asset],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
              }
            ) ? (
              <FixedAssets />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        {/* <Route path="/addFixedAsset" element={<AssetModel />} /> */}
        {/* <Route path="/depreciations" element={<Depreciations />} /> */}
        <Route
          path="/disposed"
          element={
            findUserOnlyOnePremission(
              "Voucher.Asset.DisposedAsset.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <Disposed />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/location"
          element={
            findUserOnlyOnePremission(
              "Master.AssestsLocation.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <AssetLocation />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />

        <Route path="*" element={<ResourceNotFound pageHeight="100%" />} />
      </Routes>
    </div>
  );
};
export default AssetsNestedRoute;
